<template>
  <div class="container1">
    <van-search placeholder="输入要查询的地址"  />
    <iframe id="geoPage" width=0 height=0 frameborder=0  style="display:none;" scrolling="no"
    src="https://apis.map.qq.com/tools/geolocation?key=YEQBZ-KHBK5-UXEIE-QYYJ7-YEVP7-VKBRG&referer=myapp">
</iframe>
  </div>
</template>

<script>
import { Search } from "vant";
export default {
  components: {
    vanSearch: Search
  },
  mounted() {
    // this.init();
  }
}
</script>

<style scoped lang="scss">
.container1 {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
}
</style>
